export default __webpack_public_path__ + "static/media/loading_animation.a01184d8.gif";